<script>
  import { tausender_trenner } from "./UtilsBalkenProgress.svelte";
  import { find_help_text_if_exists } from "./Utils.svelte";

  export let max_value;

  let heigth = 150;
  let text_box_heigh = 7;

  export let background_color_mitte = "#ffffff";
  export let border_color_mitte = "#FFFFFF";

  export let vorgaenger_box_color = false;
  export let deactivated_animals_from_animals_table = 0;

  export let is_basis_balken = false;
  export let oberer_text;
  export let unterer_text;

  export let is_total = false;

  export let gruen;
  export let gruen_davon_new_cust;
  export let deactivated_animals = 0;
  export let basis;

  export let helptexts;
  export let in_show_helptext_id;

  function lower_heigth_increase(max_value, gruen) {
    var heigth_faktor = heigth / max_value;
    return gruen * heigth_faktor;
  }

  function lower_heigth_new_cust(max_value) {
    var heigth_faktor = heigth / max_value;
    return gruen_davon_new_cust * heigth_faktor;
  }

  function vorgaenger_heigth(max_value, gruen, basis) {
    var heigth_faktor = heigth / max_value;
    return basis * heigth_faktor - deactivated_heigth(max_value, gruen);
  }

  function deactivated_heigth(max_value) {
    var heigth_faktor = heigth / max_value;
    return (deactivated_animals_from_animals_table + deactivated_animals) * heigth_faktor;
  }

  function upper_heigth(max_value, gruen, basis) {
    // if (is_total > 0 || basis == 74225) {
    //   console.log("==============================")
    //   console.log("is_total: ", is_total)
    //   console.log("vorgaenger_heigth: ", vorgaenger_heigth(max_value, gruen, basis))
    //   console.log("lower_heigth_increase: ", lower_heigth_increase(max_value, gruen, basis))
    //   console.log("deactivated_heigth: ", deactivated_heigth(max_value, gruen, basis))
    //   console.log("new cust heigth: ", lower_heigth_new_cust(max_value, gruen, basis))
    //   console.log("upper_heigth: ", (
    //   heigth -
    //   (vorgaenger_heigth(max_value, gruen, basis) +
    //     lower_heigth_increase(max_value, gruen, basis) +
    //     +lower_heigth_new_cust(max_value, gruen, basis))
    // ))
    // }

    return (
      heigth -
      (vorgaenger_heigth(max_value, gruen, basis) + lower_heigth_increase(max_value, gruen) + +lower_heigth_new_cust(max_value, gruen))
    );
  }
</script>

<div class="center-outer" style="margin-left: 0px;margin-right: 0px;margin-top: 0px;">
  <table height="{heigth}px;">
    <tr height="{upper_heigth(max_value, gruen, basis)}px;">
      <div class="breite"><!-- &nbsp; --></div>
    </tr>
    <tr height="{text_box_heigh}px;">
      <div
        class="breite borderstyle"
        max-height="{upper_heigth(max_value, gruen, basis)}px;"
        style="background-color: {background_color_mitte}; font-weight: 500; border: solid {border_color_mitte}  0.25pt; text-align: center; vertical-align: middle; padding:0px;"
      >
        {tausender_trenner(oberer_text)}
      </div>
    </tr>

    <tr style="height: 1px; max-height: 1px; padding:0px;">
      <div style="height: 1px; max-height: 1px;"><!-- &nbsp; --></div>
    </tr>

    <!-- //DER INCREASED BY NEW CUSTOMER BALKEN: -->
    <tr height="{lower_heigth_new_cust(max_value, gruen)}px;">
      <td style="vertical-align: center; padding:0px; height:100%;">
        <div
          class="breite"
          style="height:100%; color:#455F51; max-height:{lower_heigth_new_cust(max_value, gruen)}px;
          text-align:  center; vertical-align: center; background-color: #AFCB08;"
        >
          {#if is_total}
            +{tausender_trenner(gruen_davon_new_cust)}
          {/if}
        </div>
      </td>
      {#if is_total}
        <td class="hoverclass" style="vertical-align: top">
          <div
            class="breite einmarker"
            style="
            max-height:{lower_heigth_new_cust(max_value, gruen)}px;
              text-align:  center;height: 12px;  color: #FFFFFF; background-color: #AFCB08;"
          >
            New
          </div>
          <div class="info-box-auf-hoehe">
            {#if find_help_text_if_exists(helptexts, "marketing_mirror_active_boli_3")}
              {@html find_help_text_if_exists(helptexts, "marketing_mirror_active_boli_3")}
            {:else}
              <p>
                <strong>New boluses (new customers)</strong> &hellip; Total number of new boluses from new customers. A &ldquo;new
                bolus&rdquo; is a bolus that has been activated during the reporting timeframe. Such bolus activation is considered as
                <strong>&ldquo;new bolus from a new customer&rdquo;</strong> if it is activated within 6 months of the month in which the customer
                signed up for the contract.
              </p>
              <p>
                Example: A customer&acute;s contract signing date is in January 2023. All boluses activated in the period 01/2023 &ndash;
                07/2023 (=month of contract signing + 6 months) are considered as &ldquo;new bolus from new customers&rdquo;. From 08/2023
                onwards, new boluses from this customer will be shown as "Increase".
              </p>
            {/if}
            {#if in_show_helptext_id}
              <div style="font-size: 7px">id: marketing_mirror_active_boli_3</div>
              <div style="font-size: 7px">
                [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
              </div>
            {/if}
          </div>
        </td>
      {/if}
    </tr>

    <!-- //DER INCREASED BALKEN:  -->
    <tr height="{lower_heigth_increase(max_value, gruen)}px;">
      <td style="vertical-align: center; padding:0px; height:100%;">
        <div
          class="breite"
          style="height:100%; max-height:{lower_heigth_increase(max_value, gruen)}px;
          text-align:  center; vertical-align: center; background-color: #AFC5B9;"
        >
          {#if is_total}
            {#if gruen_davon_new_cust}
              <div style="color:#455F51;">
                +{tausender_trenner(gruen)}
              </div>
            {/if}
          {/if}
        </div>
      </td>
      {#if is_total}
        <td class="hoverclass" style="vertical-align: top">
          <div
            class="breite einmarker"
            style="
            max-height:{lower_heigth_increase(max_value, gruen)}px;
              text-align:  center;height: 12px;  color: #000000; background-color: #AFC5B9;"
          >
            Incr.
          </div>
          <div class="info-box-auf-hoehe">
            {#if find_help_text_if_exists(helptexts, "marketing_mirror_active_boli_2")}
              {@html find_help_text_if_exists(helptexts, "marketing_mirror_active_boli_2")}
            {:else}
              <p>
                <strong>Increase</strong> &hellip; Total number of boluses activated during the reporting timeframe excluding &ldquo;New boluses
                (new customers)&rdquo;.
              </p>
              <p>This number is an indicator for the number of bolus activations due to bolus replacement (remounting).</p>
            {/if}
            {#if in_show_helptext_id}
              <div style="font-size: 7px">id: marketing_mirror_active_boli_2</div>
              <div style="font-size: 7px">
                [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
              </div>
            {/if}
          </div>
        </td>
      {/if}
    </tr>

    <!-- // BASISBALKEN -->
    {#if basis > 0}
      <!-- <tr height="{vorgaenger_heigth(max_value, gruen, basis)}px;"> -->
      <tr>
        <td class="text-align:center;" style="padding:0px;">
          <div
            class="breite"
            style="position:relative; justify-content: center; display: flex; {vorgaenger_box_color
              ? 'background-color: ' + vorgaenger_box_color + '; color: ' + '#000000; vertical-align: bottom;'
              : 'vertical-align: top; '} {is_basis_balken ? 'color: #FFFFFF;' : 'color: green;'} 
               opacity: 1.0;
               border-top: solid 0.25pt #d9d9d9;
               border-left: solid 0.25pt #d9d9d9;
               border-right: solid 0.25pt #d9d9d9;
               text-align: center;

       {vorgaenger_heigth(max_value, gruen, basis) > 20 ? 'padding-top: 2px;' : 'padding-top: 0px;'} 
       
       height:{vorgaenger_heigth(max_value, gruen, basis)}px;
       "
          >
            {#if !is_total && !is_basis_balken}
              <div style="min-height: 15px; height:0px; top:0%; position:absolute;">+{tausender_trenner(gruen_davon_new_cust)}</div>
              <div style="color: #455F51; min-height: 15px; height:0px; top:15%; position:absolute;">+{tausender_trenner(gruen)}</div>
            {/if}

            <div style="color:#455F51; min-height: 15px; top:50%; position:absolute;">{tausender_trenner(basis)}</div>
          </div>
        </td>
        {#if is_total}
          <td class="hoverclass">
            <div
              class="breite"
              style="text-align:  center;
            height:{vorgaenger_heigth(max_value, gruen, basis) >= 12 ? 12 : vorgaenger_heigth(max_value, gruen, basis)}px;
            color: #000000; background-color: #d9d9d9"
            >
              Basis
            </div>
            <div class="info-box-auf-hoehe">
              {#if find_help_text_if_exists(helptexts, "marketing_mirror_active_boli_1")}
                {@html find_help_text_if_exists(helptexts, "marketing_mirror_active_boli_1")}
              {:else}
                <p>
                  <strong>Basis</strong> &hellip; Difference between the total number of active boluses at the end of the reporting timeframe
                  and the number of new boluses, the number of increase boluses, the number of decrease boluses and the number of churn boluses.
                </p>
              {/if}
              {#if in_show_helptext_id}
                <div style="font-size: 7px">id: marketing_mirror_active_boli_1</div>
                <div style="font-size: 7px">
                  [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                </div>
              {/if}
            </div>
          </td>
        {/if}
      </tr>
    {/if}
  </table>
</div>

<style>
  .center-outer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div {
    /*    height: 100%;*/
    font-size: 10px;
    overflow: hidden;
    text-overflow: auto;
    white-space: nowrap;
  }
  .breite {
    width: 40px;
  }
  .center-text {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  /*tr {
    width: 40px;
  }*/

  td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  tr {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 11.5px;
    height: auto;
    width: auto;
    margin-left: 40px;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: inherit;
    /*    left: inherit;*/
    right: 0%;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 11.5px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 30px;
    left: 30px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
